import $api from "@/api/index";

const state = {
  request: null,
  doneComment: null,
  historyInfo: {
    request_history_count: "",
    like_count: "",
    read_count: "",
    is_public: true,
    is_pause: false,
  },
};

const getters = {
  GET_REQUEST: (state) => state.request,
  GET_HISTORY_INFO: (state) => state.historyInfo,
  GET_DONE_COMMENT: (state) => state.doneComment,
};

const mutations = {
  SET_REQUEST: (state, data) => {
    state.request = data;
    state.historyInfo = {
      request_history_count: data.request_history_count,
      like_count: data.like_count,
      read_count: data.read_count,
      is_public: data.is_public,
      is_pause: data.is_pause,
    };
  },
  SET_HISTORY_INFO: (state, data) => {
    state.historyInfo = data;
  },
  SET_DONE_COMMENT: (state, data) => {
    state.doneComment = data;
  },
};

const actions = {
  async load_request({ commit }, params) {
    const res = await $api.request.load_request(params);
    commit("SET_REQUEST", res);
  },

  async reset_historyInfo({ commit }) {
    commit("SET_HISTORY_INFO", {
      request_history_count: "",
      like_count: "",
      read_count: "",
      is_public: true,
      is_pause: false,
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
